'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SocialLinkedInIcon = function SocialLinkedInIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'LinkedIn' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("g", {
      fillRule: "evenodd",
      children: /*#__PURE__*/jsxRuntime.jsx("path", {
        d: "M17.6329546,17.6333991 L15.2619094,17.6333991 L15.2619094,13.9206133 C15.2619094,13.0353046 15.245021,11.8962251 14.0286103,11.8962251 C12.7935335,11.8962251 12.6050943,12.8601983 12.6050943,13.8566151 L12.6050943,17.6333991 L10.2349379,17.6333991 L10.2349379,9.99850004 L12.5095414,9.99850004 L12.5095414,11.0415822 L12.5424294,11.0415822 C12.858865,10.4411544 13.6335102,9.8082831 14.7877003,9.8082831 C17.188967,9.8082831 17.6329546,11.3891281 17.6329546,13.4455154 L17.6329546,17.6333991 Z M7.55945668,8.95408461 C6.7968112,8.95408461 6.18260604,8.33765729 6.18260604,7.57812283 C6.18260604,6.81947724 6.7968112,6.20260548 7.55945668,6.20260548 C8.31854671,6.20260548 8.93497403,6.81947724 8.93497403,7.57812283 C8.93497403,8.33765729 8.31854671,8.95408461 7.55945668,8.95408461 Z M6.37104525,17.6333991 L8.74653482,17.6333991 L8.74653482,9.99850004 L6.37104525,9.99850004 L6.37104525,17.6333991 Z M18.8146996,4 L5.17996722,4 C4.5288742,4 4,4.5164301 4,5.15285687 L4,18.844921 C4,19.4822366 4.5288742,19.9995556 5.17996722,19.9995556 L18.8146996,19.9995556 C19.4671259,19.9995556 20,19.4822366 20,18.844921 L20,5.15285687 C20,4.5164301 19.4671259,4 18.8146996,4 L18.8146996,4 Z"
      })
    })]
  }));
};
SocialLinkedInIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SocialLinkedInIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'LinkedIn'",
        "computed": false
      },
      "required": false
    }
  }
};
var SocialLinkedInIcon$1 = SocialLinkedInIcon;

exports.default = SocialLinkedInIcon$1;
//# sourceMappingURL=SocialLinkedInIcon.js.map
